var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.17375 7.06047C0.783228 7.45099 0.783228 8.08416 1.17375 8.47468L7.53771 14.8386C7.92824 15.2292 8.5614 15.2292 8.95193 14.8386C9.34245 14.4481 9.34245 13.815 8.95193 13.4244L3.29507 7.76758L8.95193 2.11072C9.34245 1.7202 9.34245 1.08703 8.95193 0.696509C8.5614 0.305985 7.92824 0.305985 7.53771 0.696509L1.17375 7.06047ZM21.8809 6.76758L1.88086 6.76758L1.88086 8.76758L21.8809 8.76758L21.8809 6.76758Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow4);
export default __webpack_public_path__ + "static/media/Arrow 4.d4c44e21cce3a1b2a3de1a0ede20ae31.svg";
export { ForwardRef as ReactComponent };